import { Controller } from "@hotwired/stimulus"

// Shows a floating back-to-top button after scrolling past threshold
export default class extends Controller {
  static targets = ["button"]
  static values = { threshold: { type: Number, default: 400 } }

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const show = window.scrollY > this.thresholdValue
    this.buttonTarget.classList.toggle("opacity-0", !show)
    this.buttonTarget.classList.toggle("pointer-events-none", !show)
    this.buttonTarget.classList.toggle("opacity-100", show)
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
